import { useIsClient } from 'usehooks-ts';

import { Card } from '@ui/uikit/components/common/Card';

import { ADS_CONSTANTS } from '../AdsConstants';
import styles from './StoreAppInlineTopCarouselBanner.module.scss';

interface Props {
  userId?: number;
  dataKey?: string;
}

export const StoreAppInlineTopCarouselSlide = ({ userId, dataKey }: Props) => {
  const isClient = useIsClient();

  return (
    <Card className={styles.card}>
      {!isClient ? (
        <div className={styles.placeholder} />
      ) : (
        <ins className={ADS_CONSTANTS.className} data-cp-user-id={userId} data-key={dataKey} />
      )}
    </Card>
  );
};
